// Module
var code = "<div class=\"cr-body\"> <table class=\"cr-internal-icon-table\"> <thead class=\"header-icon\"> <tr> <th>Icon</th> <th>Name</th> </tr> </thead> <tbody> <tr ng-repeat=\"icon in $ctrl.icons\" class=\"row-icon\"> <td class=\"img-icon\"><span class=\"{{ icon }}\"></span></td> <td class=\"name-icon\">{{ icon }}</td> </tr> </tbody> </table> </div> ";
// Exports
export default code;